import get from "lodash/get";
import merge from "lodash/merge";
import moment from "moment";
import {
  packageStatusColors,
  transferStatusColors,
  defaultDateFormat,
  clientCommands,
  packageStatusColorsByEnumValue,
} from "../appConstants";

const $STA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/app`);

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/order`);

const $STC = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/customer`);

const $STP = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/printableArea`);

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

export const getTimezone = (timestamp) =>
  new Date(timestamp).getTimezoneOffset() * 60 * 1000;

export const currencyText = (currency) => {
  let cur = "";

  switch (currency) {
    case "try":
      cur = $STA.CURRENCY_SYMBOL;
      break;

    default:
      cur = $STA.CURRENCY_SYMBOL;
  }
  return cur;
};

export const orderStatus = (status) => {
  let label = "";
  switch (status) {
    case "50":
      label = $ST.STATUS.WAITING_CANCELLATION;
      break;
    case "100":
      label = $ST.STATUS.CANCELLED;
      break;
    case "300":
      label = $ST.STATUS.WAITING_PAYMENT;
      break;
    case "350":
      label = $ST.STATUS.WAITING_APPROVAL;
      break;
    case "400":
      label = $ST.STATUS.APPROVED;
      break;
    case "450":
      label = $ST.STATUS.PREPARING;
      break;
    case "500":
      label = $ST.STATUS.SHIPPED;
      break;
    case "510":
      label = $ST.STATUS.APPROVED;
      break;
    case "520":
      label = $ST.STATUS.CAME_TO_STORE;
      break;
    case "550":
      label = $ST.STATUS.DELIVERED;
      break;
    case "600":
      label = $ST.STATUS.REFUNDED;
      break;
    default:
      label = "";
      break;
  }
  return label;
};

export const antdSelecBoxFilterHandler = (input, option) => {
  const searchedText = input.toLowerCase();
  const _option = option.props.children.toLowerCase();
  return _option.indexOf(searchedText) >= 0;
};

export const removeElFromArrayByName = (arr, el) => {
  arr.splice(arr.indexOf(el), 1);
  return arr;
};

export const thumbnailImageUrl = (url, width, height, quality = 90) => {
  if (url) {
    const imageUrl = url.match(/([^('"\\]+)\.(jpg|png|jpeg|gif)/i);
    //_cropTop
    const imageSize = width && height ? `_size${width}x${height}` : "";
    const imageName = imageUrl[1];
    const imageQuality = quality ? `_quality${quality}` : "";
    let newImageName = imageName + imageSize + imageQuality;

    return url.replace(imageName, newImageName);
  }
  return "";
};

export const formatDate = (date) => {
  try {
    date = date.slice(0, 10);
  } catch (error) {
    return "";
  }

  let str = date.split("-");
  switch (str[1]) {
    case "01":
      str[1] = "Ocak";
      break;
    case "02":
      str[1] = "Şubat";
      break;
    case "03":
      str[1] = "Mart";
      break;
    case "04":
      str[1] = "Nisan";
      break;
    case "05":
      str[1] = "Mayıs";
      break;
    case "06":
      str[1] = "Haziran";
      break;
    case "07":
      str[1] = "Temmuz";
      break;
    case "08":
      str[1] = "Ağustos";
      break;
    case "09":
      str[1] = "Eylül";
      break;
    case "10":
      str[1] = "Ekim";
      break;
    case "11":
      str[1] = "Kasım";
      break;
    case "12":
      str[1] = "Aralık";
      break;
    default:
      str[1] = "";
  }

  return `${str[2]} ${str[1]} ${str[0]}`;
};

export const formatENDate = (date) => {
  try {
    date = date.slice(0, 10);
  } catch (error) {
    return "";
  }

  let str = date.split("-");
  switch (str[1]) {
    case "01":
      str[1] = "January";
      break;
    case "02":
      str[1] = "February";
      break;
    case "03":
      str[1] = "March";
      break;
    case "04":
      str[1] = "April";
      break;
    case "05":
      str[1] = "May";
      break;
    case "06":
      str[1] = "June";
      break;
    case "07":
      str[1] = "July";
      break;
    case "08":
      str[1] = "August";
      break;
    case "09":
      str[1] = "September";
      break;
    case "10":
      str[1] = "October";
      break;
    case "11":
      str[1] = "November";
      break;
    case "12":
      str[1] = "December";
      break;
    default:
      str[1] = "";
  }

  return `${str[2]} ${str[1]} ${str[0]}`;
};

export const urlParser = (url = "") => {
  const split = url.split("?");

  if (split.length === 2) {
    const queryString = split[1];
    let filters = [];
    let sorters = [];
    let obj = {};

    queryString.split("&").forEach((item) => {
      const params = item.split("=");
      obj[params[0]] = params[1];

      if (params[0] === "sorter") {
        sorters.push(obj);
      } else {
        filters.push(obj);
      }

      obj = {};
    });

    return {
      base: split[0],
      filters: filters,
      sorters: sorters,
    };
  } else {
    return {
      base: split[0],
      filters: [],
      sorters: [],
    };
  }
};

export const removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
    return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
};

/**
 *
 * @example objectSelector({path1: {path2: {path3: {}}}}, "path1.path2.path3", {})
 * @return path3
 */

export const objectSelector = (obj, path = "", defaultParams) => {
  const pathKeys = path.split(".");
  let object = Object.assign({}, obj);

  for (let i = 0; i < pathKeys.length; i++) {
    let key = pathKeys[i];
    if (!object || !Object.prototype.hasOwnProperty.call(object, key)) {
      object = defaultParams;
      break;
    }
    object = object[key];
  }
  return object;
};

/***
 * @example parameterizedString("my name is %s1 and surname is %s2", "John", "Doe");
 * @return "my name is John and surname is Doe"
 *
 * @firstArgument {String} like "my name is %s1 and surname is %s2"
 * @otherArguments {String | Number}
 * @returns {String}
 */
export const parameterizedString = (...args) => {
  const str = args[0];
  const params = args.filter((arg, index) => index !== 0);
  if (!str) return "";
  return str.replace(/%s[0-9]+/g, (matchedStr) => {
    const variableIndex = matchedStr.replace("%s", "") - 1;
    return params[variableIndex];
  });
};

export const toQueryString = (obj) => {
  if (!obj || Array.isArray(obj) || typeof obj !== "object") return "";
  let query = "";
  for (const key in obj) {
    if (hasOwnProperty.call(obj, key)) {
      query += obj[key] ? `${key}=${obj[key]}&` : "";
    }
  }
  return `?${query}`;
};

export const isRequestSuccessful = (statusCode) =>
  statusCode >= 200 && statusCode < 300;

export function isDefined(obj) {
  return obj !== undefined && obj !== null;
}

export function isDefinedAndNotEmpty(obj) {
  if (typeof obj === "string")
    return obj !== undefined && obj !== null && obj !== "";
  else if (Array.isArray(obj))
    return obj !== undefined && obj !== null && obj.length;
  else return isDefined(obj);
}

export function getObjectFromString(valuePath, obj) {
  return get(obj, valuePath);
}

export function mergeObjects(firstObj, secondObj) {
  return merge(firstObj, secondObj);
}

export function getRandom(max = 10000) {
  return (new Date().getTime() * Math.random()) % (max + 1);
}

export function dateFormatter(
  dateObject = new Date(),
  dateFormat = defaultDateFormat
) {
  if (!isDefinedAndNotEmpty(dateObject)) return "";
  return moment(dateObject).format(dateFormat);
}

export function getStatusColor(stateIdOrEnumValue, type) {
  let getColors = [];
  if (typeof stateIdOrEnumValue === "number") {
    getColors = packageStatusColors;
  } else if (typeof stateIdOrEnumValue === "string") {
    getColors = packageStatusColorsByEnumValue;
  }

  switch (type) {
    case "package": {
      const statusColor = getColors.find(
        (item) => item.stateId === stateIdOrEnumValue
      );
      if (statusColor) return statusColor.value;
      break;
    }
    case "transfer": {
      const statusColor = transferStatusColors.find(
        (item) => item.stateId === stateIdOrEnumValue
      );
      if (statusColor) return statusColor.value;
      break;
    }
    default:
      break;
  }
}

export const copyClipboard = (text) => {
  const event = document.createElement("textarea");
  event.value = text;
  document.body.appendChild(event);
  event.select();
  document.execCommand("copy");
  document.body.removeChild(event);
};

export const isCommandAvailable = (command) => {
  return clientCommands.some(
    (clientCommand) => clientCommand.command === command
  );
};

export const hasAnyKey = (object) => {
  return Object.keys(object).length > 0;
};

/**
 *
 * @example getCommandById(1, [{id: 1, name: 'test'}])
 * // returns {id: 1, name: 'test'}
 * @param {Number | String} commandId
 * @param {Array} buttons
 * @returns {Object}
 */
export const getActionParams = (commandId, buttons) => {
  const actionParams = buttons.find(({ id }) => id === commandId);
  return actionParams;
};

export const sortByGivenKeys = (arr, obj, path) => {
  return arr.sort((a, b) => {
    if (obj.indexOf(a[path]) > obj.indexOf(b[path])) return 1;
    else if (obj.indexOf(a[path]) < obj.indexOf(b[path])) return -1;
    else return 0;
  });
};

export const getIsoDate = (date = moment(), unitOfTime = "day") => {
  if (!date || !unitOfTime) return "";
  return date.startOf(unitOfTime).toISOString(true);
};

export const hasFormErrors = (fields) =>
  Object.keys(fields).some((field) => fields[field]);

export function getNested(obj, ...args) {
  return args.reduce((obj, level) => obj && obj[level], obj);
}

export const phoneMaskAsteriks = (phone) => {
  if (!phone) return "Girilmemiş";
  return `${phone.substr(0, 2)}${"*".repeat(phone.length - 4)}${phone.substr(
    -2
  )}`;
};

export const maskPhoneNumberWithSymbol = (phone, symbol = "*") => {
  if (Boolean(phone) && Boolean(symbol)) {
    // replace string except last 4 digit
    return phone.replace(/\d(?=\d{4})/g, symbol);
  }
  return $STC.NOT_ENTERED;
};

export const maskEmailWithSymbol = (email, symbol = "*") => {
  if (Boolean(email) && Boolean(symbol)) {
    return (
      email
        .split("@")
        // replace string except first 2 digit
        .map(
          (value) => value.slice(0, 2) + value.slice(2).replace(/./g, symbol)
        )
        .join("@")
    );
  }
  return $STC.NOT_ENTERED;
};

/**
 * Solves equations of the form a * x = b
 * @example
 * // returns {"1":[{"a":1,"b":2}],"3":[{"a":3,"b":2}]}
 * groupBy([{a: 1, b: 2}, {a:3, b:2}], (item) => item.a);
 */
export function groupBy(arr, callback) {
  return arr.reduce(
    // eslint-disable-next-line no-sequences
    (obj, v, i, a, k = callback(v)) => ((obj[k] || (obj[k] = [])).push(v), obj),
    {}
  );
}

/**
 * @example removeLeadingZeros("00000000123456789");
 * @return "123456789"
 *
 * @param {String} str
 * @returns {String}
 */
export const removeLeadingZeros = (str) => {
  if (typeof str !== "string") return "";
  return str.replace(/^0+/, "");
};

export const formatNumberWithCurrency = (value = 0) =>
  `${parseFloat(value).toFixed(2).replace(/\./g, ",")} ${$STP.CURRENCY}`;

/**
 * @param {Number} original_price
 * @param {Number} discounted_price
 * @returns {Number}
 */
export function calculateDiscount(original_price, discounted_price) {
  return (((original_price - discounted_price) / original_price) * 100).toFixed(
    0
  );
}

export const getLocalItem = (item) => {
  const localItem = localStorage.getItem(`${item}`);
  if (!!localItem && !["undefined", "null"].includes(String(localItem)))
    return localItem;

  return null;
};

export const removeLocalItem = (name) => {
  if (name && typeof name === "string") {
    localStorage.removeItem(name);
  }
};

export const setLocalItem = (name, value) => {
  localStorage.setItem(`${name}`, JSON.stringify(value));
};

export const setAuthSession = (data = {}) => {
  /* Set localStorage for auth persistance */
  const expires = moment().add($A.SESSION_EXPIRED_MINUTES, "minutes").format();
  setLocalItem("authSession", { expires, ...data });
};

export const removeAuthSession = () => {
  removeLocalItem("authSession");
};

export const checkAuthSession = () => {
  try {
    const authSession = JSON.parse(getLocalItem("authSession"));
    const authSessionExpires = objectSelector(authSession, "expires", "");

    if (authSessionExpires) {
      const expires = new Date(authSessionExpires);

      if (new Date() < expires) {
        return true;
      }
      removeAuthSession();
    }

    return false;
  } catch (error) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/theme/utils.js